// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6e451bbf","455":"7760a7f7","977":"8968df44"}[chunkId] + ".chunk.js";
};